module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-circles-bigger-7081b38bf47d79c94b31e8c10ca3f041.svg";